document.addEventListener('alpine:init', () => {
  Alpine.data('VariantDropDown', () => ({
    expanded: false,
    init() {
      window.addEventListener('dropdown:opened', (e) => {
        if (e.detail && e.detail.source === 'variant-dropdown') return;
        this.close();
      });
    },
    toggle() {
      if (this.expanded) {
        this.close();
        return;
      }

      this.$refs.button.focus();
      this.expanded = true;
      this.$refs.panel.style.display = '';

      window.dispatchEvent(new CustomEvent('dropdown:opened', { detail: { source: 'variant-dropdown' } }));

      const selectedEl = this.$refs.panel.querySelector('[aria-selected]');

      if (selectedEl) {
        this.$focus.focus(selectedEl);
      } else {
        this.$focus.within($refs.panel).first();
      }
    },
    close(focusAfter) {
      if (!this.expanded) return;

      this.expanded = false;

      this.$refs.panel.style.display = 'none';

      if (focusAfter) {
        this.$focus.focus(focusAfter);
      }
    },
  }));
});




// new broken code

// document.addEventListener('alpine:init', () => {
//   Alpine.data('VariantDropDown', ({ id, position }) => ({
//     expanded: false,
//     currentVariant: null,
//     option: {}, // Store the option data here

//     toggle() {
//       if (this.expanded) {
//         this.close();
//         return;
//       }

//       // Focus on the button for the first option
//       this.$refs[`button-${id}-${position}-0`].focus();
//       this.expanded = true;
//       this.$refs[`panel-${id}-${position}-0`].style.display = ''; // Show the dropdown

//       const selectedEl = this.$refs[`panel-${id}-${position}-0`].querySelector('[aria-selected="true"]');
//       if (selectedEl) {
//         selectedEl.focus();
//       } else {
//         this.$refs[`panel-${id}-${position}-0`].firstElementChild.focus(); // Focus on the first element
//       }
//     },
//     close(focusAfter) {
//       if (!this.expanded) return;

//       this.expanded = false;
//       this.$refs[`panel-${id}-${position}-0`].style.display = 'none'; // Hide the dropdown

//       if (focusAfter) {
//         focusAfter.focus();
//       }
//     },
//     selectVariant(variantId, optionValue) {
//       this.currentVariant = optionValue; // Update the current variant
//       this.close(); // Close the dropdown after selection
//       // Additional logic to handle variant selection can be added here
//     },
//   }));
// });




// original code

// document.addEventListener('alpine:init', () => {
//   Alpine.data('VariantDropDown', () => ({
//     expanded: false,
//     toggle() {
//       if (this.expanded) {
//         this.close();
//         return;
//       }

//       this.$refs.button.focus();

//       this.expanded = true;

//       /**
//        * We’re setting the `display` style directly instead of
//        * using `x-show` because `x-show` can cause arbitrary
//        * delays that are long enough to impact focus behaviour.
//        *
//        */
//       this.$refs.panel.style.display = '';

//       const selectedEl = this.$refs.panel.querySelector('[aria-selected]');

//       if (selectedEl) {
//         this.$focus.focus(selectedEl);
//       } else {
//         this.$focus.within($refs.panel).first();
//       }
//     },
//     close(focusAfter) {
//       if (!this.expanded) return;

//       this.expanded = false;

//       this.$refs.panel.style.display = 'none';

//       if (focusAfter) {
//         this.$focus.focus(focusAfter);
//       }
//     },
//   }));
// });

